"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MetadataManager_1 = __importDefault(require("./MetadataManager"));
const KEY = 'sequence_number';
/**
 * Class for handling logic related to the sequence number.
 */
class SequenceNumberHandler {
    /**
     * Get the current sequence number.
     *
     * @returns The current sequence number.
     */
    getSequenceNumber() {
        const metadata = MetadataManager_1.default.getApplicationMetadata();
        return (metadata === null || metadata === void 0 ? void 0 : metadata.applicationId)
            ? Number(sessionStorage.getItem(metadata.applicationId.concat('_', KEY)))
            : 0;
    }
    /**
     * Reset sequence number to the default value.
     */
    resetSequenceNumber() {
        this.setSequenceNumber(0);
    }
    /**
     * Increment the current sequence number.
     */
    incrementSequenceNumber() {
        const value = this.getSequenceNumber();
        const updateValue = value + 1;
        this.setSequenceNumber(updateValue);
    }
    /**
     * Set the sequence number.
     *
     * @param value Sequence number to store.
     */
    setSequenceNumber(value) {
        const metadata = MetadataManager_1.default.getApplicationMetadata();
        if (metadata === null || metadata === void 0 ? void 0 : metadata.applicationId) {
            sessionStorage.setItem(metadata.applicationId.concat('_', KEY), String(value));
        }
    }
}
exports.default = SequenceNumberHandler;
//# sourceMappingURL=SequenceNumberHandler.js.map